module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2r"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('span', {
    staticClass: "caslona"
  }, [_vm._v("A C K N O W L E D G M E N T S")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "NewAsterLTStd"
  }, [_vm._v("I am deeply grateful to the many people who have made this book possible:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "NewAsterLTStd"
  }, [_vm._v("My editor, Laurie Chittenden, for opening her heart to this story and helping to make it even better; and my agent, Maria Massie, for her help and advice.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "NewAsterLTStd"
  }, [_vm._v("The members of QuiltNet, for their friendship and generosity.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "NewAsterLTStd"
  }, [_vm._v("My teachers, especially Percival Everett and James Walton, who told me I could do this.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "NewAsterLTStd"
  }, [_vm._v("The members of the Internet Writing Workshop, especially Lani Kraus, list owner, who supervises a wonderful forum for aspiring writers; Dave Swinford, administrator of the novels list and one of the nicest people on the net; Jody Ewing, for her kindness; and Candace Byers, Warren Richardson, and Lesli Richardson for their critiques.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "NewAsterLTStd"
  }, [_vm._v("My friend Christine Johnson, who read every chapter and never failed to encourage me when I needed it most.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "NewAsterLTStd"
  }, [_vm._v("Geraldine, Nic, and Heather Neidenbach; Virginia and Edward Riechman; and Leonard and Marlene Chiaverini, for their love and support.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('span', {
    staticClass: "NewAsterLTStd"
  }, [_vm._v("And most of all, to my husband, Marty, for everything.")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f2ecaf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 69
// module chunks = 0